import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';

type TabProps = MuiTabProps;

export const Tab = ({ children, ...otherProps }: TabProps) => {
  return (
    <MuiTab disableRipple {...otherProps}>
      {children}
    </MuiTab>
  );
};
